import React from 'react';
import { Box, Text } from '@wix/design-system';
import Check from 'wix-ui-icons-common/Check';
import MinusSmall from 'wix-ui-icons-common/MinusSmall';
export const FeatureRowValue = ({ text, isEnabled, classNames, dataHook, }) => {
    const HasFeatureIndicator = () => isEnabled ? (React.createElement(Check, { className: classNames?.check })) : (React.createElement(MinusSmall, { className: classNames?.minus }));
    return (React.createElement(Box, { textAlign: "center", className: classNames?.container, dataHook: dataHook }, text ? (React.createElement(Text, { size: "small", className: classNames?.text }, text)) : (React.createElement(HasFeatureIndicator, null))));
};
//# sourceMappingURL=FeatureRowValue.js.map